export default __webpack_public_path__ + "static/media/hajD.e8860382.jpg";